import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthSelectors } from 'app/auth/store/auth.selectors';

@Injectable({
  providedIn: 'root', // <--- this makes it globally available
})
export class PermissionService {
  private store = inject(Store);

  hasPermission(permissionName: string | string[]): boolean {
    const userPermissions = this.store.selectSnapshot(AuthSelectors.getPermissions);
    const requiredPermissions = Array.isArray(permissionName)
      ? permissionName
      : permissionName.split(/\s+/).filter(Boolean);

    return requiredPermissions.some((perm) =>
      userPermissions.some((userPerm: Record<string, string>) => Object.keys(userPerm)[0] === perm)
    );
  }
}
